import React from "react";
import "./login.scss";
import {
  Form,
  Field,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import FormPasswordField from "../../components/formFields/FormPasswordField";
import {
  passwordValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import { useNavigate } from "react-router-dom";
import { employeeLogin } from "./loginSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import Logo from "../../assets/Images/Logo.png";
import { motion } from "framer-motion";

const LoginNew: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const loading = useAppSelector((state) => state.login.loading);

  const handleSubmit = async (values: any) => {
    const data: any = {
      UserName: values.UserName,
      Password: values.Password,
    };
    const response = await dispatch(employeeLogin(data));
    if (response?.meta?.requestStatus === "fulfilled") {
      navigate("/");
    }
  };

  return (
    <div className="container-fluid bg-secondary login-container">
      <div
        className="container position-relative"
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 1.2, opacity: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeInOut",
          }}
        >
          <div className="login-wrapper">
            <div className="row">
              <div className="col-md-12 text-center pt-3 pb-3">
                <motion.img
                  src={Logo}
                  alt={"Logo"}
                  className="head-logo"
                  initial={{ y: -20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                />
                <motion.p
                  className="text-center mt-4 mb-2 fw-600"
                  style={{
                    color: "#174583",
                  }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3, duration: 0.5 }}
                >
                  Welcome Back !
                </motion.p>
                <motion.p
                  className="text-center mb-2"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3, duration: 0.5 }}
                >
                  Log in to continue.
                </motion.p>
                <Form
                  onSubmit={handleSubmit}
                  initialValues={{
                    UserName: "",
                    Password: "",
                    RememberMe: false,
                  }}
                  render={(formRenderProps: FormRenderProps) => (
                    <FormElement className="pt-2">
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                      >
                        <Field
                          name={"UserName"}
                          type={"text"}
                          component={FormTextField}
                          label={"User Name"}
                          validator={requiredValidator}
                          astrike={true}
                          onChange={(e) => {
                            formRenderProps.onChange("UserName", {
                              value: e.value.slice(0, 10),
                            });
                          }}
                          onKeyDown={(e: any) => {
                            if (
                              e.key === "Enter" &&
                              formRenderProps.allowSubmit
                            ) {
                              formRenderProps.onSubmit(e);
                            }
                          }}
                        />
                      </motion.div>
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                      >
                        <Field
                          name={"Password"}
                          type={"password"}
                          component={FormPasswordField}
                          label={"Password"}
                          astrike={true}
                          validator={passwordValidator}
                          onKeyDown={(e: any) => {
                            if (
                              e.key === "Enter" &&
                              formRenderProps.allowSubmit
                            ) {
                              formRenderProps.onSubmit(e);
                            }
                          }}
                        />
                      </motion.div>
                      <motion.div
                        style={{ marginTop: 30 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.6, duration: 0.5 }}
                      >
                        <ButtonWithLoading
                          label="Login"
                          themeColor="primary"
                          type="submit"
                          width="100%"
                          style={{ borderRadius: 30, height: 35 }}
                          disabled={!formRenderProps.allowSubmit || loading}
                          loading={loading}
                        />
                      </motion.div>
                    </FormElement>
                  )}
                />
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LoginNew;
